import { render } from "./Banner.vue?vue&type=template&id=4b09fbee&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=4b09fbee&lang=scss&scoped=true"

import exportComponent from "D:\\code\\h5\\officialWeb-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b09fbee"]])

export default __exports__